import { API } from "../../../api/api";
import { VppsAPIRoutes } from "./apiRoutes";

const getVppsUsers = ({ skip, top, search }) => {
    let parameters = [];
    parameters.push(`acc_is_active eq 0`);

    let filter = parameters.join(" and ");
    return API.request({
        routeID: VppsAPIRoutes.GET_VPPS_USERS,
        odataParameters: {
            skip,
            top,
            filter: filter,
            search: search,
            orderby: "-id"
        }
    });
};

const getSubsidiaries = () => {
    const odataParameters = {
        skip: 0,
        top: 10000
    };
    return API.request({
        routeID: VppsAPIRoutes.GET_SUBSIDIARIES,
        odataParameters
    });
};

const createVpp = vpp => {
    return API.request({
        routeID: VppsAPIRoutes.CREATE_VPP,
        parameters: vpp,
        formData: true
    });
};

const getVpps = ({ skip, top, search, subsidiaries, users, range }) => {
    let parameters = [];
    if (subsidiaries && subsidiaries.length > 0)
        parameters.push(`subsidiary_id in (${subsidiaries
            .map(c => c)
            .join(",")},)`)
    if (users && users.length > 0) parameters.push(`user_id in (${users
        .map(c => c)
        .join(",")},)`);
    if (range) {
        if (range.start && range.start.length > 0)
            parameters.push(`timestamp ge '${range.start}'`);
        if (range.end && range.end.length > 0)
            parameters.push(`timestamp le '${range.end}'`);
    }

    let filter = parameters.join(" and ");
    return API.request({
        routeID: VppsAPIRoutes.GET_VPPS,
        odataParameters: {
            skip,
            top,
            filter: filter,
            orderby: "-id",
            search: search
        }
    });
};

const getVppsUsersById = ({ ids }: { ids: number[] }) => {
    return API.request({
        routeID: VppsAPIRoutes.GET_VPPS_USERS,
        odataParameters: {
            skip: 0,
            top: 1000000,
            ...(ids.length && { filter: `id in (${ids
                    .map(c => c)
                    .join(",")},)`}),
            orderby: "-id"
        }
    });
};

const deleteVpp = id => {
    return API.request({
        routeID: VppsAPIRoutes.DELETE_VPP,
        routeParameters: {
            video_id: id
        }
    });
};

export const vppsAPI = {
    getVppsUsers,
    getSubsidiaries,
    createVpp,
    getVpps,
    getVppsUsersById,
    deleteVpp
};
